"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductActivationPropsInterface = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _upgradeDataPropsInterface = require("ui-addon-upgrades/_core/common/data/upgradeData/interfaces/upgradeDataPropsInterface");

var ProductActivationPropsInterface = (0, _extends2.default)({}, _upgradeDataPropsInterface.upgradeDataPropsInterface, {
  onSuccess: _propTypes.default.func.isRequired
});
exports.ProductActivationPropsInterface = ProductActivationPropsInterface;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/_core/productActivation/ProductActivationPropsInterface.js
// module id = 776
// module chunks = 5 6